import { CALC_ENDPOINTS } from '@makemydeal/dr-dash-store/constants';

export const PS_ERROR_MESSAGE_MAP: Record<string, string> = {
    tradeinpaymentinfoupdate_ensurethisvalueislessthanorequalto:
        'Adjustment resulted money back to the customer and is currently not supported.',
    updatedofferpriceimmediate_ensurethisvalueisgreaterthanorequalto: 'The selling price is below the minimum value',
    updatedretailpriceoverride_ensurethisvalueislessthanorequalto: 'MSRP/Retail Price and Selling Price must be under $1,000,000.',
    updatedsellrateoverride_ensurethattherearenomorethandigitsbeforethedecimalpoint: 'The sell rate exceeds the maximum rate',
    selectedterm_ensurethisvalueisgreaterthanorequalto: 'Terms range from 12 to 108 months, subject to lender restrictions.',
    updatedbuyrateoverride_ensurethattherearenomorethandigitsbeforethedecimalpoint: 'The buy rate exceeds the sell rate',
    selectedterm_ensurethisvalueislessthanorequalto: 'Terms range from 12 to 108 months, subject to lender restrictions.',
    terms_ensurethisvalueisgreaterthanorequalto: 'Terms range from 12 to 108 months, subject to lender restrictions.',
    terms_ensurethisvalueislessthanorequalto: 'Terms range from 12 to 108 months, subject to lender restrictions.',
    updatedofferpriceimmediate_ensurethisvalueislessthanorequalto: 'MSRP/Retail Price and Selling Price must be under $1,000,000.',
    updatedofferpriceimmediate_negativeamortization: 'The selling price is below the minimum value',
    tradeinpaymentinfoupdate_negativeamortization: 'Adjustment resulted money back to the customer and is currently not supported.',
    excesstradein_equitywillbereturnedtothecustomer:
        // {} is a placeholder interpolated at runtime with the unsupported deal type (e.g., "Finance", "Lease")
        'Excess trade‑in equity results in money back to the customer. {} is not supported. Try a cash deal or adjust the trade‑in.',
    excesstradein_equitywillbereturnedtothecustomer_cash: 'Excess trade‑in equity will be returned to the customer.',
    updatedsellrateoverride_avalidintegerisrequired: 'The updated sell rate is invalid.',
    selectedterm_termsmustbegreaterthanorequalto: 'Terms range from 12 to 108 months, subject to lender restrictions.',
    updateddownpaymentimmediate_negativeamortization: 'Zero loan balance or lease cap cost below residual.',
    selectedcredittier_fatalprogramisnotavailable:
        'We couldn’t find a program for the selected credit tier. Please verify the credit score.',
    feetypeid_thisfieldisrequired: "Fee type invalid:The selected fee code  isn't valid. Please choose a different option.",
    fatalmonthstermisnotsupported: 'Terms range from 12 to 108 months, subject to lender restrictions.',
    fatalnoratewasfoundforcreditscore: 'No rate found',
    fatalvehicleinvoicemustbenonzero: 'The selling price is below the minimum value',
    sellratemustbegreaterorequaltobuyrate: 'The buy rate exceeds the sell rate',
    sellrateshouldbelessthanorequalto: 'The sell rate exceeds the maximum rate',
    ensuretermisgreaterthanorequalto: 'Terms range from 12 to 108 months, subject to lender restrictions.',
    invalidinputparameterquotetermvalue: 'Terms range from 12 to 108 months, subject to lender restrictions.',
    residualisrequiredforleaseballoondeals:
        'Residual value required. Enter the residual value to continue with the payment calculation.',
    fatalexceededmaximuminitialmilesof: "The selling vehicle's odometer exceeds the lender requirements on initial mileage.",
    rateexpiredon:
        'The updated offer type is no longer available as the program expired. Please use Program & Incentives to choose a new program.',
    notaxlocationsfound:
        'Tax Location Not Found:Enter a valid U.S. ZIP code. Military and U.S. territory codes aren’t supported; use a different ZIP code to continue.',
    fatalresidualcouldnotbefoundindatabase:
        'Residual Data Not Found:We couldn’t find residual data for this vehicle. It may not be eligible for this program—please choose a different vehicle.',
    novalidvehiclesforstyleid:
        'Vehicle Not Found:We couldn’t find a valid vehicle for the style ID provided; check the VIN and confirm it’s not a heavy truck, exotic make, future-release model, or older than 1994.',
    novalidvehiclesforvin:
        'Vehicle Not Found:We couldn’t match the VIN to a valid vehicle. Make sure it’s not a heavy truck, exotic make, future-release model, or older than 1994.',
    cannotfindamatchforspecifiedsinglepayment:
        'Payment Match Not Found:The selected program isn’t available or doesn’t support this deal setup; choose a different one from the Program & Incentives screen that matches your deal structure.',
    fatalgoalnotobtainable:
        'Deal Couldn’t Be Calculated:We couldn’t calculate a balanced deal with the user input deal values and the current configuration. Try adjusting the vehicle sale price or cash down.',
    fatalprogramisnotavailable:
        'Program Not Available:The selected program isn’t available. It may have expired or is not supported for this vehicle.',
    vehiclecouldnotbefoundindatabase:
        'Vehicle Not Found:We couldn’t locate the vehicle in our database. It may be missing or incorrectly configured.',
    fatalmonthsnomileagechartvaluefound:
        'Initial Mileage Not Supported:The vehicle’s odometer reading exceeds the lender’s supported initial mileage range. To continue, select a vehicle with fewer miles.',
    partnercodeorcommonpartnerrequired:
        'Payment Issue:The sell rate override results in a payment that doesn’t fully cover the deal over time; review the configuration and adjust related deal variables like pricing, term, or incentives to meet the target.',
    paymentrequestedcouldnotbefound:
        "Partner Configuration Required:The dealer's partner code is missing or not configured properly to proceed; please contact the Cox Automotive sales support team to resolve this issue.",
    sellrateandorbuyrateisrequired: 'Sell Rate and/or Buy Rate is required',
    gap_adjusted_by_lender: 'GAP price adjusted due to lender rules',
    updatedshoppercontact_notaxlocationsfoundforgivenzipcode: 'No tax locations found for the given ZIP code.',
    updatedshoppercontactretry_unabletogetstatefromzipcode: 'Unable to get state from zipcode.',
    updatedpaymentfrequency_fatalonepaynotavailable: 'One Pay Not Available',
    fatalonepaynotavailableonfinanceorretail: 'One Pay is not available for Finance or Retail.',
    fatalfeesandtaxescannotbecappedononepay:
        'Fees and taxes can’t be capped when using the One Pay option. Set all fees and taxes to upfront.',
    termslessthannotallowedforannualmileslessorequalto:
        'The selected term isn’t available for the current annual mileage. Change the term or annual miles.',
    applydealerdiscounts_ensurethisvalueisgreaterthanorequalto: 'Selling price must be $0 or more.',
    updateddownpaymentimmediate_ensurethisvalueislessthanorequalto: 'Down payments must be less than $1,000,000',
    residualshouldbelessthanorequaltowhenresidualtypeisp: 'Residual percentage cannot be greater than 100%',
    ratetypeshouldbeiforaretaildeal:
        'Unable to process your request. Please switch to Lease, switch MF to APR, then switch back to Retail and try again.',
    recalculateprofitdetails_ensurethisvalueislessthanorequalto:
        'Selling price must be less than $1,000,000. Please reduce the selling price and try again.',
    vehicleyear_ensurethisvalueisgreaterthanorequalto: 'Please enter a valid four-digit model year for the vehicle.',
    fatalvehicleretailmustbenonzero:
        'Please enter a valid MSRP (new vehicles) or retail value (used vehicles). This field cannot be zero.',
    terms_avalidintegerisrequired: 'Terms range from 12 to 108 months, subject to lender restrictions.',
    novalidlendersforcommonpartnerandzipcode: "Lenders didn't return any programs.",
    validquotesareempty: "Lenders didn't return any programs.",
    postalcode_unabletomappostalcodetoaspecificstate: 'Unable to map postal code to a specific state.',
    postalcode_ensurethisfieldhasatleastcharacters: 'Ensure postal code has at least 5 characters.'
};

/**
 * Error message keys that should pass through the server message as-is.
 * These keys indicate that the original server message contains dynamic values
 * and should be displayed without modification.
 */
export const PS_ERROR_PASS_THROUGH_KEYS = new Set([
    'residualbelowminimumof',
    'residualizedmsrpbelowminimumallowedof',
    'residualexpiredon'
]);

/**
 * Error messages that vary based on calculation endpoint (PQ vs UPQ).
 * Maps calculation endpoints to their error-specific messages.
 */
export const PS_ERROR_MAP_BY_CALC_ENDPOINT: Record<string, Record<string, string>> = {
    [CALC_ENDPOINTS.programQuotes]: {
        fatalnoresidualwascalculated:
            'The residual value was not calculated for this program. Turn off Auto Select Program to build your deal.',
        fatalnobaseresidualwasfound:
            "The residual value isn't available for this program. Turn off Auto Select Program to build your deal.",
        fatalnomrmcrvvaluefound:
            'The MRM/CRV value was not found for this vehicle. Turn off Auto Select Program to build your deal.'
    },
    [CALC_ENDPOINTS.userProgramQuotes]: {
        fatalnoresidualwascalculated: 'The residual value was not calculated for this program. Please enter a residual value.',
        fatalnobaseresidualwasfound: "The residual value isn't available for this program. Please enter a residual value.",
        fatalnomrmcrvvaluefound: 'The MRM/CRV value was not found for this vehicle. Please enter a residual value.'
    }
};

/**
 * The `programQuotes` branch as it reads while `enableExplicitLenderP1` is on. The checkbox
 * those messages instruct the user to uncheck is no longer on screen, so every key the UPQ branch
 * also answers falls back to the UPQ wording, which names an action that is still available.
 *
 * Derived rather than written out: overlaying UPQ onto PQ keeps the two copies from drifting, and a
 * future PQ-only key survives here instead of degrading to the generic fallback.
 */
export const PS_ERROR_MAP_PROGRAM_QUOTES_ASP_HIDDEN: Record<string, string> = {
    ...PS_ERROR_MAP_BY_CALC_ENDPOINT[CALC_ENDPOINTS.programQuotes],
    ...PS_ERROR_MAP_BY_CALC_ENDPOINT[CALC_ENDPOINTS.userProgramQuotes]
};

export const BALLOON_PS_ERROR_MESSAGE_MAP: Record<string, string> = {
    residualisrequiredforleaseballoondeals:
        'Balloon Payment required. Enter the balloon payment to continue with the payment calculation.'
};

export const NEGATIVE_AMORTIZATION_PS_ERROR_MESSAGE_MAP: Record<string, string> = {
    finance:
        'There is too much equity to allow for a loan balance. Verify the selling price, reduce the equity from cash or trade-in, or consider doing this as a Cash deal.',
    lease: 'There is too much equity to allow for a lease payment. Verify the selling price, reduce the equity from cash or trade-in, or consider doing this as a Finance or Cash deal.',
    balloon:
        'There is too much equity to allow for a loan payment based on depreciation. Verify the selling price, reduce the equity from cash or trade-in, or consider doing this as a Finance or Cash deal.',
    cash: 'There is more equity than the balance due. Verify the selling price or reduce the equity from cash or trade-in.'
};
